import Swiper from 'swiper';

import { breakpointUpTo } from './utils';

(function ($) {
  var projectTestimonialsSlider = new Swiper('.js-testimonials-slider', {
    spaceBetween: 16,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
    navigation: {
      nextEl: '.js-testimonials-slider-btn-next',
      prevEl: '.js-testimonials-slider-btn-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.25,
        spaceBetween: 16,
      },
      560: {
        slidesPerView: 2.3,
        spaceBetween: 16,
      },
      740: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
    on: {
      afterInit: function () {
        addExpandClass();
      },
      resize: function () {
        addExpandClass();
      },
    },
  });

  // Calculate whether content should be expandable
  // only for small screens
  function addExpandClass() {
    if (breakpointUpTo('small')) {
      $('.js-testimonials-more-text-inner').each(function () {
        var $this = $(this);

        if (
          $this.height() > 160 &&
          !$this.parent().hasClass('has-expand-btn')
        ) {
          $this.parent().addClass('has-expand-btn');
        }
      });
    }
  }

  // Expand content
  $('.js-expand-height-btn').on('click', function () {
    var $content = $(this).closest('.js-testimonials-more-text-body');

    $content
      .find('.js-testimonials-more-text-inner')
      .toggleClass('is-expanded');

    $(this).toggleClass('is-expanded');
  });
})(jQuery);
